import { Spinner, SpinnerSize, Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ArticleApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ArticleDetailPage } from "./ArticleDetailPage";

export interface IArticleItemPageProps {}

export const ArticleItemPage: React.FunctionComponent<IArticleItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(ArticleApi);

  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Articles), route: ERoutes.article },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsColor"
        onChange={(newTabId) => history.push(`${ERoutes.article}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.article} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ArticleDetailPage articleId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
